module.exports = __webpack_public_path__ + "static/media/imqge.bb03aaf0.png";